export const formatCvDocumentTitle = (userName: string, cvAlias?: string): string => {
  const normalizedUserName = userName.trim();

  if (!normalizedUserName) {
    return "CV";
  }

  return ["CV", normalizedUserName, cvAlias?.trim()].filter(Boolean).join(" - ");
};
